var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function SearchResults(el) {
    var $el = $(el);

    var resultsEmpty = $el.find('.js-search-results-empty');
    var resultsList = $el.find('.js-search-results-list');
    var buttonDidYouMean = $el.find('.js-did-you-mean');
    var searchBottom = $el.find('.js-search-bottom');

    var searchHeader = resultsList.find('.js-search-header');
    var searchFavoriteGroup = resultsList.find('.search-results__favorite-group');
    var cardSimple = resultsList.find('.card-simple');
    var search_message = $('.js-search-result');

    if (search_message.length && search_message[0]) {
        search_message[0].focus();
    }

    if (resultsList) {
        resultsEmpty.hide();
    }

    if (buttonDidYouMean.length > 0) {
        searchHeader.hide();
        searchBottom.hide();
        searchFavoriteGroup.hide();
        cardSimple.hide();
        resultsEmpty.show();
    }
}

module.exports = SearchResults;
